module.exports = __webpack_public_path__ + "static/media/20191214_160745.496eb1dc.jpg";